import { HttpClient } from '@angular/common/http';
import { ConfigService, AppConfig } from './config.service';
import { AppInitializationService } from './app-initialization.service';

export function configLoader(http: HttpClient, configService: ConfigService, appInitService: AppInitializationService): () => Promise<void> {
  return (): Promise<void> => {
    return new Promise((resolve, reject) => {
      http.get<AppConfig>('/assets/config.json')
        .subscribe({
          next: (config: AppConfig) => {
            configService.setConfig(config);
            appInitService.initializeApp();
            resolve();
          },
          error: (error) => {
            console.error('Failed to load configuration:', error);
            reject(error);
          }
        });
    });
  };
}
